import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { SharedUser } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<SharedUser>>>;

const addUsersToSession = (
    id: string,
    users: Array<string>,
    role: string,
    message?: string,
): ReturnType => {
    return Request.post(`/workouts/sessions/${id}/users`, {
        users,
        role,
        message,
    });
};

export default addUsersToSession;
